import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { I18nProvider } from "@/i18n/I18nContext";
import { useAttribution } from "@/hooks/useUtmCapture";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import LeadIntake from "@/pages/LeadIntake";
import Chatbot from "@/pages/Chatbot";
import Estimator from "@/pages/Estimator";
import CareMatch from "@/pages/CareMatch";
import CityLanding from "@/pages/CityLanding";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import MyCases from "@/pages/MyCases";
import Dashboard from "@/pages/Dashboard";
import AuthVerify from "@/pages/AuthVerify";
import AttorneyAccept from "@/pages/AttorneyAccept";
import AttorneyDashboard from "@/pages/AttorneyDashboard";
import AttorneyCaseDetail from "@/pages/AttorneyCaseDetail";
import "@/App.css";

function AppRoutes() {
  useAttribution();
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/intake" element={<LeadIntake />} />
      <Route path="/chat" element={<Chatbot />} />
      <Route path="/estimator" element={<Estimator />} />
      <Route path="/find-care" element={<CareMatch />} />

      {/* City landing pages — SEO-targeted */}
      <Route path="/brooklyn" element={<CityLanding citySlug="brooklyn" />} />
      <Route path="/queens" element={<CityLanding citySlug="queens" />} />
      <Route path="/bronx" element={<CityLanding citySlug="bronx" />} />
      <Route path="/manhattan" element={<CityLanding citySlug="manhattan" />} />
      <Route path="/newark" element={<CityLanding citySlug="newark" />} />
      <Route path="/jersey-city" element={<CityLanding citySlug="jersey-city" />} />

      {/* Claimant auth */}
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Register />} />
      <Route path="/auth/verify" element={<AuthVerify />} />
      <Route
        path="/my-cases"
        element={
          <ProtectedRoute redirectTo="/login">
            <MyCases />
          </ProtectedRoute>
        }
      />

      {/* Attorney portal */}
      <Route path="/attorney/accept" element={<AttorneyAccept />} />
      <Route
        path="/attorney"
        element={
          <ProtectedRoute roles={["attorney"]} redirectTo="/login">
            <AttorneyDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/attorney/cases/:id"
        element={
          <ProtectedRoute roles={["attorney"]} redirectTo="/login">
            <AttorneyCaseDetail />
          </ProtectedRoute>
        }
      />

      {/* Admin */}
      <Route path="/admin/login" element={<Login />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute role="admin" redirectTo="/admin/login">
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
